// tslint:disable: max-line-length

import { getStyle } from './DatanauswertungGenerischStyles';
import * as React from 'react';
import { WpdfText } from '../pdf/WpdfText.';
import { WpdfView } from '../pdf/WpdfView';

export function renderHeader(header: any, isPDF: boolean, fontFactor?: number, config?: any) {
    const { custom_layout } = config;
    return (
        <WpdfView
            style={{ ...getStyle('header', isPDF, fontFactor, custom_layout), ...header.customStyle }}
            pdf={isPDF}
        >
            {header.blocks.map((block: any, idx: number) => renderBlock(block, isPDF, idx, fontFactor, config))}
        </WpdfView>
    );
}

export function renderTitle(header: any, isPDF: boolean, fontFactor?: number, config?: any) {
    const { custom_layout } = config;
    const title: string | JSX.Element = (header || {}).title;
    if (!title || isPDF) {
        return null;
    }
    return (
        <WpdfView
            style={{ ...getStyle('tableTitle', isPDF, fontFactor, custom_layout) }}
            pdf={isPDF}
        >
            {title}
        </WpdfView>
    );
}

function renderBlock(block: any, isPDF: boolean, idx: number, fontFactor?: number, config?: any) {
    const { custom_layout } = config;
    const bdlf = idx === 0 ? { borderLeft: 0 } : {};
    const label: string = Array.isArray(block.label)
        ? (isPDF ? block.label[1] || block.label[0] || null : block.label[0] || null)
        : block.label || null;
    // console.log(label, isPDF, getStyle('header_text_block', isPDF));
    return (
        <WpdfView
            key={`block-${idx}`}
            style={{ ...getStyle('header_block', isPDF, fontFactor, custom_layout), width: block.width }}
            pdf={isPDF}
        >
            <WpdfView
                style={{ ...getStyle('header_text_block', isPDF, fontFactor, custom_layout), ...block.customStyle, ...bdlf }}
                pdf={isPDF}
            >
                <WpdfText
                    pdf={isPDF}
                >
                    {label}
                </WpdfText>
            </WpdfView>
            {block.columns &&
                <WpdfView
                    style={{ ...getStyle('header_cols', isPDF, fontFactor, custom_layout) }}
                    pdf={isPDF}
                >
                    {block.columns.map((column: any, idxCol: number) => {
                        if (column.customStyleLabel && column.customStyleLabel.fontSize && !isNaN(column.customStyleLabel.fontSize)) {
                            if (!isPDF) {
                                column.customStyleLabel.fontSize = `${column.customStyleLabel.fontSize * 1.2}pt`;
                            }
                        }
                        const extraStyle: React.CSSProperties = {};
                        const label1: string = Array.isArray(column.label)
                            ? (isPDF ? column.label[1] || column.label[0] || null : column.label[0] || null)
                            : column.label || null;
                        const label2: string = Array.isArray(column.label2)
                            ? (isPDF ? column.label2[1] || column.label2[0] || null : column.label2[0] || null)
                            : column.label2 || null;
                        if (idxCol === 0 && idx === 0) {
                            extraStyle.borderLeftWidth = '0pt'; // Gleiche Farbe wie bg
                        }
                        return (
                            <WpdfView
                                key={`column-${idxCol}`}
                                style={{ ...getStyle('header_text_col', isPDF, fontFactor, custom_layout), ...column.customStyleColumn, ...extraStyle }}
                                pdf={isPDF}
                            >
                                {label1 &&
                                    <WpdfText
                                        style={{
                                            ...getStyle('header_text_field', isPDF, fontFactor, custom_layout),
                                            ...(label2 ? { flex: 'unset', height: '50%' } : {}),
                                            ...column.customStyleLabel
                                        }}
                                        pdf={isPDF}
                                    >
                                        {label1}
                                    </WpdfText>
                                }
                                {label2 &&
                                    <WpdfText
                                        pdf={isPDF}
                                        style={{
                                            ...getStyle('header_text_field', isPDF, fontFactor, custom_layout),
                                            ... { flex: 'unset', height: '50%' },
                                            ...column.customStyleLabel2
                                        }}
                                    >
                                        {label2}
                                    </WpdfText>
                                }
                            </WpdfView>
                        );
                    })}
                </WpdfView>
            }
        </WpdfView>
    );
}
